import { render, staticRenderFns } from "./TitlesAndPromotions.vue?vue&type=template&id=7b3bc4e8&"
import script from "./TitlesAndPromotions.vue?vue&type=script&lang=ts&"
export * from "./TitlesAndPromotions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports